import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center paper-bg px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm border border-[rgba(212,175,55,0.25)] bg-black/40 p-8"
        data-testid="admin-login-card"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <span className="font-heading text-gold-metallic text-5xl leading-none">BR</span>
          <p className="font-script text-xl text-[var(--champagne)] mt-1">Bruna Reis</p>
          <p className="font-body text-[0.55rem] uppercase tracking-[0.35em] text-[var(--muted)] mt-2">
            Painel Administrativo
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="font-body text-xs text-[var(--nude)] uppercase tracking-widest">
              E-mail
            </Label>
            <Input
              id="email"
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-black/40 border-[rgba(212,175,55,0.3)] text-white focus-visible:ring-[var(--gold)]"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="font-body text-xs text-[var(--nude)] uppercase tracking-widest">
              Senha
            </Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-black/40 border-[rgba(212,175,55,0.3)] text-white focus-visible:ring-[var(--gold)]"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-red-400 font-body text-xs text-center">
              {error}
            </p>
          )}

          <Button
            type="submit"
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[var(--gold)] text-black hover:bg-[var(--champagne)] font-body uppercase tracking-[0.18em] text-xs font-semibold"
          >
            <Lock size={14} className="mr-2" strokeWidth={1.8} />
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
